// Utilities
import { mapState } from 'vuex';
export default {
  name: 'CoreToolbarMenu',
  props: {
    canCreateTickets: {
      type: Boolean,
      default: false
    },
    newTicketCount: {
      type: Number,
      default: 0
    },
    showTicketNotificationBell: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      externalLink: false
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  methods: {
    getPath(metaObj) {
      if (metaObj && metaObj.help) {
        this.externalLink = true;
        return `${this.$store.state.app.docsBaseURL}/${metaObj.help.path}`;
      } else {
        this.externalLink = false;
        return '/#/help';
      }
    },
    logout() {
      this.$emit('logout');
    }
  }
};